import { Layout } from "antd";
import React from "react";
import { useQueryClient } from "react-query";
import { UserInfo } from "../../components/molecules";
import { ModelsMenu } from "./ModelsMenu";

export const SIDEBAR_WIDTH = 236;

// Desktop navigation: company logo, model list, user footer with logout.
export const AppSidebar: React.FC<{ refetch: any }> = ({ refetch }) => {
  const queryClient = useQueryClient();
  const user: any = queryClient.getQueryData(["/current-user"]);

  return (
    <Layout.Sider
      theme="light"
      width={SIDEBAR_WIDTH}
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        bottom: 0,
        height: "100vh",
        borderRight: "1px solid #e8e8e6",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "auto",
        }}
      >
        {user?.company_logo && (
          <img
            src={user.company_logo}
            alt=""
            style={{ width: "70%", margin: "16px auto" }}
          />
        )}
        <div style={{ flex: 1 }}>
          <ModelsMenu />
        </div>
        <UserInfo refetch={refetch} />
      </div>
    </Layout.Sider>
  );
};
